import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Theme,
  Switch,
  CircularProgress,
  FormControlLabel
} from "@material-ui/core";
import {
  AddIconTwo,
  DeleteIcon,
  EditIconTwo,
  CopyIcon2,
  ViewIcon,
  ReportHistoryIcon2,
  DeviceIcon2,
  TroubleShoot,
  CloseIconColor,
  Arrow
} from '../../components/Icons';
import { FilterList } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import { environment } from "../../environments/environment";
import Cookies from "js-cookie";
import useStyles from '../maintenance/assets/styles';
import { SearchBar } from 'src/components/sub-components/SearchBar';
import { Device } from '../models';
import { Pagination } from '@material-ui/lab';
import { DeviceForm } from './DeviceForm';
import { AuthService } from '../authentication/auth.service';
import { ToasterComponent } from '../maintenance/test-automation/components/Toaster';
import { connectDeviceWithCodecInDevices, getAllBatches, getAllCodecs, getAllDevices, getDevicesPaginated, getAllProducts, getDeviceById, getDeviceSummary, getFavorites, getMetaData } from '../testing-automation/api-helper/apiHelper';import {Link,useHistory} from 'react-router-dom';
import {AddnewProductVersion} from '../maintenance/otamanager/AddnewProductVersion';
import { DialogPopup } from '../maintenance/test-automation/components/DialogPopup';

export function DeviceComponent() {
  const classes = localStyles();
  const style = useStyles();
  const history = useHistory() 
  const [searchTerm, setSearchTerm] = useState('');
  const [filterValidity, setFilterValidity] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [statusToggleDialogOpen, setStatusToggleDialogOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("none");

  const [isCloning, setIsCloning] = useState(false);
  const [formType, setFormType] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isToasterOpen, setIsToasterOpen] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [reqSuccess, setReqSuccess] = useState(false);

  const [allDevices, setAllDevices] = useState([]);
  const [allDevicesNotSorted, setAllDevicesNotSorted] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [deviceSummary, setDeviceSummary] = useState([]);
  const [sensors, setSensors] = useState([]);
  const [kitTypes, setKitTypes] = useState([]);
  const [actuators, setActuators] = useState([]);
  const [batchNumbers, setBatchNumbers] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [codecId, setCodecId] = useState("");
  const [codecs, setCodecs] = useState([]);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState('');

  const [totalElements, setTotalElements] = useState(0);

   const [formData, setFormData] = useState({
      id: '',
      name: '',
      interval: '',
      persistence: false,
      protocol: '',
      connectivity: 'GSM',
      batchNumber: '',
      simNumber: '',
      sensorCodes: [],
      actuatorCodes: [],
      productType: '',
      productId:'',
      productVersion:'',
      deviceParameterConfiguration:{},
      deviceModel: '',
      location: ''
    });

  const [errors, setErrors] = useState({
    id: null,
    name: null,
    interval: null,
    persistence: null,
    protocol: null,
    connectivity: null,
    batchNumber: null,
    sensorCodes: null,
    actuatorCodes: null,
    productType: null,
    productVersion: null,
    deviceModel: null,
    location: null
  });

    const [selectedProductTypeDetails, setSelectedProductTypeDetails] = useState(null);
    const [availableVersions,setAvailableVersions]=useState([]); //need to filter (N/A) 0.0.0 verison

  useEffect(() => {
  }, []);

  const initialDataFetch = async (targetPage = page - 1) => {
    setLoadingScreen(true);
    try {
      await Promise.all([
        fetchFavorites(),
        fetchDeviceSummary(),
        fetchDevices(targetPage, rowsPerPage),
        fetchMetaData(),
        fetchBatchNumbers(),
        fetchProducts(),
        fetchCodecs()
      ]);
    } catch (error) {
      console.error("Error in initial data fetch:", error);
    } finally {
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    initialDataFetch(0);
  }, []);

  const isFirstMount = useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    setPage(1);
    fetchDevices(0, rowsPerPage);
  }, [searchTerm, rowsPerPage, filterValidity]);

  const historyPush = (path) => {
    window.location.href = path;
  }

  const fetchCodecs = async () => {
    try {
      const data = await getAllCodecs();
      setCodecs(data || []);
    } catch (error) {
      console.error("Error fetching codecs:", error);
    }
  };

  const fetchFavorites = async () => {
    try {
      const data = await getFavorites();
      setFavorites(data || []);

    } catch (error) {
      console.error('Error fetching favorites:', error);
    }
  }

  const fetchDeviceSummary = async () => {
    try {
      const data = await getDeviceSummary();
      setDeviceSummary(data || []);

    } catch (error) {
      console.error('Error fetching device summary:', error);
    }
  }

  const fetchDevices = async (pageIndex = 0, pageSize = 10) => {
    try {
      const data = await getDevicesPaginated(pageIndex, pageSize, searchTerm, filterValidity, 'LIST');
      if (data) {
          setAllDevices(data.content || []);
          setAllDevicesNotSorted(data.content || []);
          setTotalElements(data.totalElements || 0);
      }    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  }

  const fetchMetaData = async () => {
    try {
      const data = await getMetaData();
      setSensors(data.sensors);
      setKitTypes(data.kitTypes);
      setActuators(data.actuators);

    } catch (error) {
      console.error('Error fetching meta data:', error);
    }
  }

  const fetchBatchNumbers = async () => {
    try {
      const data = await getAllBatches();
      setBatchNumbers(data || []);
    } catch (error) {
      console.error('Error fetching batch number:', error);
    }
  }

  const fetchProducts = async () => {
    try {
      const data = await getAllProducts('DETAIL');
      setAllProducts(data || []);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  const handleFilterClick = (event) => {setAnchorEl(event.currentTarget)};
  const handleFilterClose = () => {setAnchorEl(null)};
  const handleFilterSelect = (validity) => {
    setFilterValidity(validity);
    handleFilterClose();
  };

  const handleDeletePopupClose = () => {
    setSelectedDevice(null);
    setDeleteDialogOpen(false);
  }

  const handleDelete = async (device) => {
    try {
      const response = await fetch(
        `${environment.host}/core/device/${device.id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAllDevices((prevDevices) => prevDevices.filter((d) => d.id !== device.id));
      setIsToasterOpen(true);
      setToasterMessage("Device Deleted Successfully");
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message);
      setReqSuccess(false);
    } finally {
      setSelectedDevice(null);
      setDeleteDialogOpen(false);
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const toggleDeviceMode = async (device) => {
    const newStatus = device.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    try {
      setLoadingScreen(true);

      const response = await fetch(
        `${environment.host}/core/device/${device.id}/mode`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
          body: newStatus,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAllDevices((prevDevices) =>
        prevDevices.map((d) =>
          d.id === device.id ? { ...d, status: newStatus } : d
        )
      );

      setIsToasterOpen(true);
      setToasterMessage(`Device status changed to ${newStatus}`);
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message || error.message || 'Error toggling device status');
      setReqSuccess(false);

    } finally {
      setSelectedDevice(null);
      setStatusToggleDialogOpen(false);
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const getDevicesFiltered = () => {
    return allDevices || [];
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage); // Ensure both variables are updated
    fetchDevices(newPage - 1, rowsPerPage);
  };

  const sort = (colName) => {
    let nextSortOrder = sortOrder === 'asc' ? 'desc' : sortOrder === 'desc' ? 'none' : 'asc';
    setSortOrder(nextSortOrder);

    if (nextSortOrder === 'none') {
      setAllDevices([...allDevicesNotSorted]);
    } else {
      const sortedDevices = [...allDevices].sort((a, b) => {
        if (!a[colName] && !b[colName]) return 0;
        if (!a[colName]) return 1;
        if (!b[colName]) return -1;

        const multiplier = nextSortOrder === 'desc' ? -1 : 1;
        return (a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0) * multiplier;
      });
      setAllDevices(sortedDevices);
    }
  };

  const getIcon = () => {
    if (sortOrder === 'asc') {
      return '&#9650;'; // ▲
    } else if (sortOrder === 'desc') {
      return '&#9660;'; // ▼
    }
    return '';
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedDevice(null);
    setErrors({
      id: null,
      name: null,
      interval: null,
      persistence: null,
      protocol: null,
      connectivity: null,
      batchNumber: null,
      sensorCodes: null,
      actuatorCodes: null,
      productType: null,
      productVersion: null,
      deviceModel: null,
      location: null
    })
    setFormData({
      id: '',
      name: '',
      interval: '',
      persistence: false,
      protocol: '',
      connectivity: 'GSM',
      batchNumber: '',
      simNumber: '',
      sensorCodes: [],
      actuatorCodes: [],
      productType: '',
      productId:'',
      productVersion:'',
      deviceParameterConfiguration:{},
      deviceModel: '',
      location: ''
    })
  };

  const handleCloseVersion = () => {
    setIsAddPopupOpen(false);
  }

   const handleAddVersion=(version)=>{
    const alreadyExists = selectedProductTypeDetails.versions.some(
      (v) => v.versionNum === version.versionNum
    );

    if (alreadyExists) {
      console.warn('Version already exists:', version.versionNum);
      return;
    }
    let versionAdded=[...selectedProductTypeDetails.versions,version];
    let productDetailedUpdated={...selectedProductTypeDetails,versions:versionAdded};
    setSelectedProductTypeDetails(productDetailedUpdated);
    const updatedList = allProducts.map(item =>
      item.productName === productDetailedUpdated.productName ? productDetailedUpdated : item
    );
    setAllProducts(updatedList);
    const  availableVersionsAdded=[...availableVersions,version] //ensure 0.0.0 not inclueded 
    setAvailableVersions(availableVersionsAdded);
    setSelectedVersion(version.versionNum);

    
    let deviceParameterConfiguration = {};
    console.log(selectedProductTypeDetails);

    console.log('selectedVersionDetails',version["remoteConfigurations"],version["versionNum"])
    if(version&&version["remoteConfigurations"]&&version["versionNum"]){
      deviceParameterConfiguration["device"]=formData.name;
      deviceParameterConfiguration["versionNum"]=version["versionNum"];
      deviceParameterConfiguration["productType"]=formData.productType;
      deviceParameterConfiguration["remoteConfigurations"]=updateRemoteConfigurations(formData.name,version["remoteConfigurations"])

    setFormData({
      ...formData,
      productVersion:version.versionNum,
      deviceParameterConfiguration:deviceParameterConfiguration
      })
      setErrors((prev) =>({
        ...prev,
        productVersion:null
      }))
    }
    else {
      console.log('Invalid selectedVersionDetails or missing required properties.');
    }
  }

  const updateRemoteConfigurations = (deviceName,remoteConfigurations) => {

    // Regular expression to match any text inside curly braces
    const regex = /{([^}]+)}/g;
  
    let updatedRemoteConfigurations = remoteConfigurations.map(config => {
      if (regex.test(config.defaultValue)) {
        return {
          ...config,
          defaultValue: config.defaultValue.replace(regex, deviceName)
        };
      }
      return config;
    });
   return updatedRemoteConfigurations;
  };

  const handleDeviceSave = async (deviceData, type) => {
    setLoadingScreen(true);

    const userId = Cookies.get("USER_ID");
    const token = Cookies.get("ACCESS_TOKEN");

    const url =
      type === "EDIT"
        ? `${environment.host}/core/user/${userId}/device/${deviceData.id}`
        : `${environment.host}/core/user/${userId}/device`;

    const method = type === "EDIT" ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(deviceData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      connectDeviceWithCodecInDevices(codecId, deviceData.id)
      setCodecId("");
      setIsToasterOpen(true);
      setToasterMessage("Device " + (formType === "EDIT" ? "Updated" : "Created") + " Successfully");
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message);
      setReqSuccess(false);
    } finally {
      setSelectedDevice(null)
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
      const nextPage = formType === "EDIT" ? page - 1 : 0;
      if (formType !== "EDIT") {
        setPage(1);
        setCurrentPage(1);
      }
      initialDataFetch(nextPage);
    }
  };

  const handleSubmit = (deviceData) => {
    if (!AuthService.isSuperAdmin() && !AuthService.hasNewUserAccess) {
      return;
    }
    if (formType === "EDIT") {
      handleDeviceSave(deviceData, "EDIT");
    } else {
      handleDeviceSave(deviceData, "ADD");
    }
    console.log('Device submitted:', deviceData);
    handleClose();
  };

  const openDeviceForm = async (type: string, device?: any) => {
    setFormType(type);
    if (type === "EDIT" || type === "CLONE") {
      setLoadingScreen(true);
      try {
        const fullDevice = await getDeviceById(device.id);
        setSelectedDevice(fullDevice);
        setModalOpen(true);
      } catch (error) {
        console.error("Error fetching device details:", error);
      } finally {
        setLoadingScreen(false);
      }
    } else {
      setSelectedDevice(null);
      setModalOpen(true);
    }
  };

  const handleToggle = (device) => {
    setStatusToggleDialogOpen(true);
    setSelectedDevice(device)
  };

  const createExpectedMessageFormat = (data) => {
    if (data.lastDecodeData || data.lastRawActuatorData) {
      let recievedLastRawData = data.lastDecodeData ? data.lastDecodeData
        .split('|').pop()
        .replace(/;$/, '') : '';
      let lastActuatorData = data.lastRawActuatorData? data.lastRawActuatorData :'';
      let connectedSensor = data.sensorCodes || []
      let connectedActuator = data.actuatorCodes || []
      let expectedFormat
      let validity;
      let sensorFormat;
      let actuatorFormat;
      if (connectedSensor.length === 0 && connectedActuator.length === 0) {
        expectedFormat = 'There is no sensor or actuators connected.';
      } else {
        const sensorValue = Object.assign({}, recievedLastRawData.split(';'),lastActuatorData.split(';'));
        sensorFormat = connectedSensor
          .map(function (device, index) {
            const value = sensorValue.hasOwnProperty(device) ? (sensorValue as any)[device] : 0;
            return index + '-' + device + ':' + value;
          })
          .join(';');
        actuatorFormat = connectedActuator
          .map(function (device, index) {
            const value = sensorValue.hasOwnProperty(device) ? (sensorValue as any)[device] : 0;
            return index + '-' + device + ':' + value;
          })
          .join(';');
        expectedFormat = sensorFormat && actuatorFormat ? sensorFormat + '*' + actuatorFormat : sensorFormat + actuatorFormat;
      }
      validity = isSameSensorFormat(sensorFormat, recievedLastRawData) || isSameSensorFormat(actuatorFormat,lastActuatorData)
      return validity;
    } else {
      return false
    }

  }

  const isSameSensorFormat = (data1, data2) => {
    const getKeys = d => new Set(d.split(';').map(i => i.split(':')[0]));

    const k1 = getKeys(data1);
    const k2 = getKeys(data2);

    if (k1.size !== k2.size) return false;

    for (let key of k1) {
      if (!k2.has(key)) return false;
    }
    return true;
  };

  return (
    <div className={classes.root}>
      <div className="page-heading">
        Device Board 
      </div>
      <div className={`testing`}>
        <Grid container className={style.container}>
          <Grid container alignItems="center">
            <Grid style={{ textAlign: "left", width: "255px", margin: " 0 10px 0 0" }}>
              <SearchBar placeholder="Search Device" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </Grid>

            <Grid item>
              <div className="filerButton" onClick={handleFilterClick}>
                <FilterList style={{ padding: "4px" }} />
                Filter
              </div>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleFilterClose} style={{top:'48px'}}>
                  {["All", "Valid", "Invalid"].map((option) => (
                    <MenuItem key={option} onClick={() => handleFilterSelect(option)}>
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: "20px" }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCell}>ID</TableCell>
                    <TableCell className={classes.tableCell}>Device Name</TableCell>
                    <TableCell className={classes.tableCell}>Data Validity</TableCell>
                    <TableCell className={classes.tableCell}>Reference</TableCell>
                    <TableCell className={classes.tableCell} onClick={() => sort('lastSeen')} style={{ cursor: 'pointer' }}>
                      Last Seen
                      <span dangerouslySetInnerHTML={{ __html: getIcon() }} />
                      {sortOrder === 'none' && (
                        <img src="../../assets/images/sort-option.svg" alt="sort" style={{ marginLeft: 4 }} />
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Mode</TableCell>
                    <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getDevicesFiltered()
                    .map((device, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#F5F5F5" : "white",
                        }}
                      >
                        <TableCell className={classes.tableCellBody}>{device.id}</TableCell>
                        <TableCell className={classes.tableCellBody}>{device.name}</TableCell>
                        <TableCell className={classes.tableCellBody}>
                          <label className={createExpectedMessageFormat(device) ? "enabled" : "disabled"}>
                            {createExpectedMessageFormat(device) ? 'Valid' : 'Invalid'}
                          </label>
                        </TableCell>
                        <TableCell className={classes.tableCellBody}>{device.referenceName}</TableCell>
                        <TableCell className={classes.tableCellBody}>{device.lastSeen}</TableCell>
                        <TableCell style={{ cursor: 'default' }} align="center">
                          <button
                            className={`${classes.activeInactiveBtn} ${device.status ? classes.active : classes.inactive
                              }`}
                          >
                            {device.status === "ACTIVE" ? 'ACTIVE' : 'INACTIVE'}
                          </button>
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBody}
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Tooltip
                            title={
                              ((device.sensorCodes && device.sensorCodes.length) || 0) === 0
                                ? "No data available"
                                : "View"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                disabled={((device.sensorCodes && device.sensorCodes.length) || 0) === 0}
                                onClick={() => historyPush(`/device/${device.id}`)}
                              >
                                <ViewIcon color={((device.sensorCodes && device.sensorCodes.length) || 0) === 0 ? "#B0B0B0" : "#707070"} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip
                            title={
                              ((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0
                                ? "No data available"
                                : "Actuator View"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                disabled={((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0}
                                onClick={() => historyPush(`/device/${device.id}/actuator`)}
                              >
                                <DeviceIcon2 color={((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0 ? "#B0B0B0" : "#707070"} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Maintenance">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => historyPush(`/device/maintenance/${device.id}`)}
                              >
                                <ReportHistoryIcon2 />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  openDeviceForm("EDIT", device);
                                }}
                              >
                                <EditIconTwo />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="TroubleShoot">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => historyPush(`/device/${device.id}/troubleshoot`)}
                              >
                                <TroubleShoot />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Clone Device">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  setIsCloning(true);
                                  openDeviceForm("CLONE", device);
                                }}
                              >
                                <CopyIcon2 />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title={device.status === "ACTIVE" ? "IN-ACTIVATE" : "ACTIVATE"} placement="top">
                            <FormControlLabel
                              style={{
                                marginLeft: 0,
                                marginRight: 0,
                              }}
                              control={
                                <Switch
                                  checked={device.status === "ACTIVE"}
                                  onChange={(event) => {
                                    const newStatus = event.target.checked ? "ACTIVE" : "INACTIVE";
                                    console.log("New status:", newStatus);
                                    handleToggle(device);
                                  }}
                                  color="default"
                                  size="small"
                                />
                              }
                              label=""
                            />
                          </Tooltip>
                          <Tooltip title="Delete">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  setSelectedDevice(device);
                                  setDeleteDialogOpen(true);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Pagination */}
          <Grid container justifyContent="center">
            {totalElements > rowsPerPage && (
              <Pagination
                className={style.pagination}
                page={page}
                onChange={handleChangePage}
                count={Math.ceil(totalElements / rowsPerPage)}
                shape="rounded"
                defaultPage={1}
              />
            )}
          </Grid>
        </Grid>

        {/* Delete Confirmation Dialog */}
        {selectedDevice && (
          <Dialog
            open={deleteDialogOpen}
            onClose={() => handleDeletePopupClose()}
            maxWidth="md"
            classes={{ paper: style.deletePopup }}
          >
            <Grid container className={style.deleteHeader}>
              <Grid item xs={10} md={10}>
                <DialogTitle>CONFIRMATION</DialogTitle>
              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton onClick={handleDeletePopupClose} style={{ paddingTop: "20px" }}>
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>

            <DialogContent className={style.deleteContent}>
              <Grid container>
                <Grid style={{ margin: "0" }}>
                  <Typography className={style.popupLabel} style={{ color: "#FF4343" }}>
                    Are you sure you want to delete this device {selectedDevice.name}?
                  </Typography>
                  <Typography className={style.popupLabel}>
                    The delete action will remove the device.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>

            <div className={style.DeletePopupFooter}>
              <Button
                variant="contained"
                onClick={handleDeletePopupClose}
                className={style.popupCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={style.popupDelete}
                onClick={() => handleDelete(selectedDevice)}
                style={{ marginRight: "21px" }}
              >
                DELETE
              </Button>
            </div>
          </Dialog>
        )}

        {/* Toggle Status Confirmation Dialog */}
        {selectedDevice && (
          <Dialog
            open={statusToggleDialogOpen}
            onClose={() => setSelectedDevice(null)}
            maxWidth="md"
            classes={{ paper: style.deletePopup }}
          >
            <Grid container className={style.deleteHeader}>
              <Grid item xs={10} md={10}>
                <DialogTitle>CONFIRMATION</DialogTitle>
              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton onClick={() => setSelectedDevice(null)} style={{ paddingTop: "20px" }}>
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>

            <DialogContent className={style.deleteContent}>
              <Grid container>
                <Grid style={{ margin: "0" }}>
                  <Typography className={style.popupLabel} style={{ color: "#FF4343" }}>
                    Are you sure you want to Change the status of device {selectedDevice.name} from {selectedDevice.status}?
                  </Typography>
                  <Typography className={style.popupLabel}>
                    The status change action will update the status of the device.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>

            <div className={style.DeletePopupFooter}>
              <Button
                variant="contained"
                onClick={() => setSelectedDevice(null)}
                className={style.popupCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={style.popupDelete}
                onClick={() => toggleDeviceMode(selectedDevice)}
                style={{ marginRight: "21px" }}
              >
                CHANGE
              </Button>
            </div>
          </Dialog>
        )}

      </div>

      {/* Add Device */}
      <div
        className="material-button-div"
        style={{ position: "fixed", bottom: 20, right: 20, zIndex: 1000 }}
      >
        <Button
          variant="contained"
          onClick={() => openDeviceForm("ADD")}
          style={{
            minWidth: "50px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#2A7CED",
            color: "#fff",
            boxShadow: "0 3px 6px rgba(0,0,0,0.275)",
            padding: 0,
          }}
        >
          <AddIconTwo color="#FFF" />
        </Button>
      </div>

      <ToasterComponent
        reqSuccess={reqSuccess}
        message={toasterMessage}
        toaster={isToasterOpen}
      />

      <DialogPopup
        open={isAddPopupOpen}
        onClose={handleCloseVersion}
        title="Add New Version"
        dialogContent={<AddnewProductVersion goBack={handleCloseVersion} addDevicePage={true} handleAddVersion={handleAddVersion} selectedProductType={selectedProductTypeDetails} />}
        buttonRequired={false}
        onSubmit={handleCloseVersion}
      />

      {/* Loading Screen */}
      {loadingScreen && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            backgroundColor: "#000000",
            opacity: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            width: "100vw",
            height: "100vh",
          }}
        >
          <CircularProgress size={80} />
        </div>
      )}

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DeviceForm
            onClose={handleClose}
            onSubmit={handleSubmit}
            allDevices={allDevices}
            selectedDevice={selectedDevice}
            isCloning={false}
            setCodecId={setCodecId}
            formType={formType}
            sensors={sensors}
            actuators={actuators}
            batches={batchNumbers}
            allProducts={allProducts}
            codecs={codecs}
            setLoading={setLoadingScreen}
            hasPermissionFor={() => true /* or your real permission check */}
            formData={formData}
            setFormData={setFormData}
            availableVersions={availableVersions}
            selectedProductTypeDetails={selectedProductTypeDetails}
            setSelectedProductTypeDetails={setSelectedProductTypeDetails}
            setIsAddPopupOpen={setIsAddPopupOpen}
            setAvailableVersions={setAvailableVersions}
            errors={errors}
            setErrors={setErrors}
          />
        </div>
      )}
    </div>
  );
}

const localStyles = makeStyles((theme: Theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
  },
  versionChip: {
    backgroundColor: "#e6edf7",
    color: "#2a7ced",
    height: "20px",
    border: `1px solid #2A7CED`,
  },
  deleteButton: {
    backgroundColor: "#F06A6A",
    color: "white",
    "&:hover": {
      backgroundColor: "#D9534F",
    },
  },
  tableCell: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
    backgroundColor: "white",
  },
  tableCellBody: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 3px 6px #00000029",
  },
  statusListStyle: {
    float: "right",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    padding: "10px",
    marginRight: "0",
  },
  statusBadgeStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
  },
  approvedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#d4f8d4",
    color: "#9cf79c",
    borderColor: "#9cf79c",
  },
  pendingStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#fde8cd",
    color: "#f8d394",
    borderColor: "#f8d394",
  },
  notApprovedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#f8d7da",
    color: "#f47c88",
    borderColor: "#f47c88",
  },
  imageBoxes: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  imageBox: {
    textAlign: "center",
    width: "28%",
    backgroundColor: "#eee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    padding: "10px",
  },
  image: {
    width: "120px",
    height: "90px",
    margin: "20px",
  },
  imgText: {
    margin: "20px",
  },
  activeInactiveBtn: {
    border: "none",
    backgroundColor: "rgb(206, 251, 204)",
    color: "green",
    borderRadius: "20px",
    padding: "5px 10px",
    width: "90%",
    cursor: "default",
  },
  active: {
    background: "#DFF2EE 0% 0% no-repeat padding-box",
    color: "#02C170",
    opacity: 1,
  },
  inactive: {
    background: "#bab9b9 0% 0% no-repeat padding-box",
    color: "#646363",
    opacity: 1,
  },
}));
